<template>
  <f7-page class="main-location-control-home">
    <!-- <f7-navbar sliding :class="{'navbar-oscuro-1': modoConexionFrm == modosConexion.CONECTADO, 'navbar-amarillo-1': modoConexionFrm == modosConexion.DESCONECTADO}" class="no-shadow"> -->
    <TheNavbar
      sliding
      :nav-title="$t('production.locations.title')"
      :style="temaBarraEstadoConexion"
      back-btn-enable
      :back-callback="CerrarFrm"
    >
      <template #right>
        <!-- Botones Movimientos Pendientes de Sincronización -->

        <div class="btn-navBar-Movimientos display-flex justify-content-center">
          <img
            v-if="movimientosPendientesSincronizar > 0"
            class="selectable"
            alt="iconUploadOn"
            src="@/static/icons/ic_upload_on.svg"
            @click="popupResumenMovimientosPendientes = true"
          >
          <img
            v-if="movimientosPendientesSincronizar === 0"
            alt="iconUploadOff"
            src="@/static/icons/ic_upload_off.svg"
          >
          <span
            v-if="movimientosPendientesSincronizar > 0"
            class="badge badge-indicadorMovimientos"
          >{{ movimientosPendientesSincronizar }}</span>
        </div>
        <!-- Botones de Cambio Modo Conexion -->
        <!-- <f7-toggle :checked="modoConexionFrm == modosConexion.CONECTADO" @change="SolicitarCambioModoConexionFormulario()" ></f7-toggle> -->
        <div @click="SolicitarCambioModoConexionFormulario()">
          <f7-button
            :title="$t('production.locations.changeConnectionMode.buttonText', { mode: statusText })"
          >
            <img
              v-if="modoConexionFrm === modosConexion.CONECTADO"
              src="@/static/icons/fa-solid-wifi_gray.svg"
              style="width: 35px; height: 32px;"
            >

            <img
              v-else-if="modoConexionFrm === modosConexion.DESCONECTADO"
              src="@/static/icons/fa-solid-wifi-slash_gray.svg"
              style="width: 35px; height: 32px;"
            >
          </f7-button>
        </div>
      </template>
    </TheNavbar>

    <!-- Escanear Codigo -->
    <UCCodeScanner
      fab-button-background-color="var(--his-darkgray)"
      :class="{ componenteUCEscanearCodigoPosicionarIzquierda: mostrarBtnConfirmarCambioDeUbicacion }"
      :allow-manual-code-entry="false"
      :auto-open-camera="true"
      @code-reading="EventoLecturaDeCodigoDeBarrasPale"
      @codigo-barras="EventoLecturaDeCodigoDeBarrasPale"
    />

    <!-- Boton Confirmar Cambio de ubicación -->

    <div
      v-if="mostrarBtnConfirmarCambioDeUbicacion"
      class="fab fab-extended fab-right-bottom fab-btnConfirmarCambioDeUbicacion"
    >
      <a
        href="#"
        class="a-fab"
        :style="{ background: '#4cd964' }"
        @click="ConfirmarCambioDeUbicacion()"
      >
        <f7-icon md="material:done" />
      </a>
    </div>

    <div class="div-cabecerafrm">
      <div class="div-componenteDeBusqueda">
        <PCBuscadorPaleConfeccionado
          ref="PCBuscadorPaleConfeccionado"
          :modo-offline="modoConexionFrm === modosConexion.DESCONECTADO"
          :buscar-codigo-de-barras="codigoDeBarrasParaBusqueda"
          :cargar-existencias-pale="true"
          :cargar-datos-pedido-venta-del-pale="true"
          class="PCBuscadorPaleConfeccionado"
        />
      </div>

      <div
        class="div-campoDeBusquedaUbicacion"
      >
        <div v-if="(modoConexionFrm === modosConexion.DESCONECTADO)">
          <UCSearchEntityERP
            ref="UCUbicaciones"
            :placeholder="$t('common.location')"
            :search-text="$t('searchEntity.location.searchText')"
            :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
            :default-etities-list="CargarUbicacionesOfline"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :focus-on-input="lecturaContinuaUbicacionesAPP"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :qr-search-show="true"
            @selection="EventUbicacionesSelected"
          />
        </div>
        <div v-if="(modoConexionFrm === modosConexion.CONECTADO)">
          <UCSearchEntityERP
            ref="UCUbicaciones"
            :placeholder="$t('common.location')"
            :search-text="$t('searchEntity.location.searchText')"
            :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
            :end-point-for-code-search="obtenerUbicacionPorCodigo"
            :end-point-for-list="obtenerUbicaciones"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :focus-on-input="lecturaContinuaUbicacionesAPP"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :qr-search-show="true"
            @selection="EventUbicacionesSelected"
          />
        </div>
      </div>
    </div>

    <div>
      <div class="div-contadorDeLecturasMultiples">
        <span class="span-texto-oscuro-14-600">
          {{ $t('production.locations.info.totalReadings', { quantity: totalLecturasMultiples }) }}
        </span>
      </div>

      <!-- LECTURA ONLINE -->
      <div v-if="(modoConexionFrm === modosConexion.CONECTADO)">
        <div
          v-if="elementosLeidosOnline.length > 0"
          class="div-registrosElementosLeidos"
        >
          <div>
            <f7-row
              v-for="elementoPale in elementosLeidosOnline"
              :key="elementoPale.Id"
              class="div-registroElementoLeido"
            >
              <f7-col
                width="40"
                @click="MostrarDetallePaleSeleccionado(elementoPale)"
              >
                <f7-row>
                  <f7-col>
                    <span
                      v-if="elementoPale.CodigoBarrasPale
                        && !elementoPale.NumeroSerie"
                      class="span-texto-teal-18-800"
                    > {{ elementoPale.CodigoBarrasPale }} </span>
                    <span
                      v-if="elementoPale.NumeroSerie"
                      class="span-texto-teal-18-800"
                    > {{ elementoPale.NumeroSerie }} </span>
                  </f7-col>
                </f7-row>
                <f7-row>
                  <f7-col>
                    <span class="span-texto-grisAzul-14-600">{{ `${$t('common.date')}:` }} </span> <span class="span-texto-grisAzul-14-400"> {{ FormatearFecha(elementoPale.FechaFabricacion) }} </span>
                  </f7-col>
                </f7-row>

                <!-- Nombre Cliente y Pedido -->
                <div
                  v-if="elementoPale.PedidoVenta != null
                    && elementoPale.PedidoVenta.Numero != null
                    && elementoPale.PedidoVenta !== undefined
                    && elementoPale.PedidoVenta.Numero !== undefined"
                  class="div-DatosDePedidoYPale"
                >
                  <f7-row>
                    <f7-col>
                      <span class="span-texto-grisAzul-14-600">{{ `${$t('common.salesOrderShort')}:` }}</span> <span class="span-texto-grisAzul-14-400">
                        {{ `${elementoPale.PedidoVenta.Serie}/${elementoPale.PedidoVenta.Numero}` }}
                      </span>
                      <span class="span-texto-grisAzul-14-600"> {{ `${$t('common.customer')}:` }}</span> <span class="span-texto-grisAzul-14-400">
                        {{ elementoPale.PedidoVenta.Cliente.Nombre }}
                      </span>
                    </f7-col>
                  </f7-row>
                </div>

                <f7-row>
                  <f7-col>
                    <img
                      alt="iconBox"
                      src="@/static/icons/ic_box.svg"
                    >
                    <span class="span-cantidadEnvases"> {{ ObtenerCantidadSumaEnvasesExistenciasDeUnPale(elementoPale) }} </span>
                  </f7-col>
                </f7-row>
              </f7-col>
              <f7-col
                width="40"
                @click="MostrarDetallePaleSeleccionado(elementoPale)"
              >
                <span
                  v-if="elementoPale.Ubicacion != null"
                  class="span-texto-amarillo-16-600"
                > {{ elementoPale.Ubicacion.Nombre }} </span>
              </f7-col>
              <f7-col width="20">
                <!-- <span @click="BorrarElementoOnline(elementoPale)"> Borrar </span> -->
                <div
                  class=" btn-action-group btn-base-rojo-1"
                  @click="BorrarElementoOnline(elementoPale)"
                >
                  <img
                    alt="iconDelete"
                    src="@/static/icons/ic_delete.svg"
                  >
                </div>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </div>

      <!-- LECTURA OFFLINE -->
      <div v-if="(modoConexionFrm === modosConexion.DESCONECTADO)">
        <div
          v-if="elementosLeidosOffline.length > 0"
          class="div-registrosElementosLeidos"
        >
          <div>
            <f7-row
              v-for="(elementoPale, i) in elementosLeidosOffline"
              :key="i"
              class="div-registroElementoLeido"
            >
              <f7-col width="40">
                <span
                  v-if="elementoPale.CodigoBarrasPale"
                  class="span-texto-teal-18-800"
                > {{ elementoPale.CodigoBarrasPale }} </span>
                <span
                  v-if="elementoPale.NumeroSerie"
                  class="span-texto-teal-18-800"
                > {{ elementoPale.NumeroSerie }} </span>
              </f7-col>
              <f7-col width="20">
                <!-- <span @click="BorrarElementoOffline(elementoPale)"> Borrar </span> -->
                <div
                  class=" btn-action-group btn-base-rojo-1"
                  @click="BorrarElementoOffline(elementoPale)"
                >
                  <img
                    alt="iconDelete"
                    src="@/static/icons/ic_delete.svg"
                  >
                </div>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </div>
    </div>

    <!----- Popup Detalle de Palé en lectura Multiple ---->
    <f7-popup
      class=""
      :opened="popupDetallePaleAbierto"
      @popup:closed="popupDetallePaleAbierto = false"
    >
      <f7-page v-if="elementoPaleSeleccionado != null">
        <f7-navbar
          no-shadow
          :title="$t('production.locations.detailsPopup.title')"
          :style="temaBarraEstadoConexion"
        >
          <f7-nav-right>
            <f7-link @click="CerrarDetallePaleSeleccionado()">
              {{ $t('common.x') }}
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <PCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones
          :mostrar-titulo="false"
          :listado-existencias="elementoPaleSeleccionado.Existencias"
          :ubicacion="elementoPaleSeleccionado.Ubicacion"
        />
      </f7-page>
    </f7-popup>

    <!----- Popup Resultado Ultimo Cambio De Ubicacion ---->
    <f7-popup
      class="popup-ResumenMovimientoRealizado"
      :opened="popupResumenMovimientoRealizado"
      @popup:closed="popupResumenMovimientoRealizado = false; CerrarResumenDeMovimientosRealizados()"
    >
      <f7-page v-if="popupResumenMovimientoRealizado">
        <template #fixed>
          <TheNavbar
            :nav-title="$t('production.locations.summaryPopup.title')"
            :popup-close-btn-enable="true"
            :style="temaBarraEstadoConexion"
          />
        </template>
        <div class="div-contenidoResumenMovimientosRealizados">
          <div
            v-if="resultadoUltimoCambioUbicacion != null && resultadoUltimoCambioUbicacion.length > 0"
          >
            <div>
              <f7-list media-list>
                <f7-list-item
                  v-for="(elementoPale, i) in resultadoUltimoCambioUbicacion"
                  :key="i"
                >
                  <template #title>
                    <span
                      :class="{
                        'span-texto-firebrick-16-800': !elementoPale.Resultado,
                        'span-texto-darkseagreen-16-500': elementoPale.Resultado,
                      }"
                    >
                      {{
                        (elementoPale.Resultado
                          ? $t('production.locations.summaryPopup.list.title.accepted')
                          : $t('production.locations.summaryPopup.list.title.rejected'))
                      }}
                    </span>
                  </template>
                  <template #subtitle>
                    <f7-row v-if="elementoPale.Resultado">
                      <f7-col width="50">
                        <span class="span-texto-gris-14-500 justify-content-center">
                          {{ $t('common.pallet') }}
                        </span>
                      </f7-col>
                      <f7-col width="50">
                        <span class="span-texto-gris-14-500">
                          {{ $t('common.destination') }}
                        </span>
                      </f7-col>
                    </f7-row>

                    <f7-row v-if="elementoPale.Resultado">
                      <f7-col width="50">
                        <span class="span-texto-teal-18-800"> {{ elementoPale.UnidadLogistica.NumeroSerie }} </span>
                      </f7-col>
                      <f7-col width="50">
                        <span class="span-texto-amarillo-16-600"> {{ elementoPale.UbicacionDestino.Nombre }} </span>
                      </f7-col>
                    </f7-row>
                    <f7-row v-if="!elementoPale.Resultado">
                      <f7-col width="100">
                        <span class="span-texto-teal-18-800"> {{ elementoPale.UnidadLogistica.NumeroSerie }} : </span>
                        <span class="span-texto-gris-16-500"> {{ elementoPale.Mensaje }} </span>
                      </f7-col>
                    </f7-row>
                  </template>
                </f7-list-item>
              </f7-list>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>

    <!----- Popup Movimientos Pendientes de Sincronizar ---->
    <f7-popup
      class=""
      :opened="popupResumenMovimientosPendientes"
      @popup:closed="popupResumenMovimientosPendientes = false; CerrarResumenDeMovimientosPendientes()"
    >
      <f7-page>
        <TheNavbar
          :nav-title="$t('production.locations.pendingMovementsPopup.title')"
          :style="temaBarraEstadoConexion"
          :popup-close-btn-enable="true"
        />
        <PCMovimientosDeAlmacenPendientesDeSincronizar
          :mostrar-titulo="true"
          :actualizar="actualizarComponenteMovimientosPendientesSincronizacion"
          :sincronizar-todo="sincronizarTodosLosMovimientosPendientes"
        />
      </f7-page>
    </f7-popup>

    <UCConfirmation
      ref="actionConfirmarCambioDeModoConexionFrmAbierto"
      :cancel="$t('production.locations.changeConnectionMode.confirmation.cancel.text').toUpperCase()"
      :confirm="$t('common.syncNow').toUpperCase()"
    />
    <UCConfirmation ref="actionUbicaciones" />
  </f7-page>
</template>

<script>
import { defineComponent, nextTick } from 'vue';
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import TheNavbar from '@/components/TheNavbar.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import SoporteGeneral from '@/js/common/HICommonSupport';
import {
  ProgramarSincronizacionDeCambiosDeUbicacionPendientes,
  guardarMovimientosDeAlmacenPendientes,
  obtenerMovimientosDeAlmacenPendientes,
} from '@/js/common/HiSynchronizationSupport';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCBuscadorPaleConfeccionado from '@/components/production/traceability/PCBuscadorPaleConfeccionado.vue';
import PCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones from '@/components/production/traceability/PCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones.vue';
import PCMovimientosDeAlmacenPendientesDeSincronizar from '@/components/production/traceability/PCMovimientosDeAlmacenPendientesDeSincronizar.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import TraceabilityController from '@/js/controllers/TraceabilityController';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default defineComponent({
  name: 'FrmLocationControlHome',
  components: {
    TheNavbar,
    PCBuscadorPaleConfeccionado,
    UCCodeScanner,
    PCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones,
    PCMovimientosDeAlmacenPendientesDeSincronizar,
    UCSearchEntityERP,
    UCConfirmation,
  },
  data() {
    return {
      modoConexionFrm: null, // Mantiene el modo del formulario, online u offline.
      modosConexion: {
        CONECTADO: 'c',
        DESCONECTADO: 'd',
      },
      totalLecturasMultiples: 0, // Controla el número de lecturas que se van realizando de forma multiple.
      codigoDeBarrasParaBusqueda: null, // Variable que se pasa al componente PCBuscadorPaleConfeccionado para que efectue las busquedas.
      elementosLeidosOnline: [],
      elementosLeidosOffline: [],
      popupDetallePaleAbierto: false,
      popupResumenMovimientosPendientes: false, // Controla la apertura del Popup de movimientos pendientes de sincronizar.
      popupResumenMovimientoRealizado: false, // Controla la apertura del Popup que muestra el resultado del ultimo movimiento/s
      elementoPaleSeleccionado: null, // Mantiene el elemento seleccionado en las lecturas multiples online
      // actionConfirmarCambioDeModoLecturaFrmAbierto: false, // Controla la apertura que confirma el cambio de modo de lectura del formulario.
      // actionConfirmarCambioDeModoConexionFrmAbierto: false, // Controla la apertura que confirma el cambio de mododo de conexion del formulario.
      // actionConfirmarSalirSinConfirmarCambios: false, // Controla la apertura del action que se muestra si hay cambios pendientes de sincronizar y conexión.
      mostrarBtnConfirmarCambioDeUbicacion: false, // Controla si se muestra el boton que confirma el cambio de ubicación.
      ubicacionDestino: null, // Mantiene la ubicación de destino seleccionada.
      actualizarComponenteMovimientosPendientesSincronizacion: null, // Cuando cambia de valor actualiza el componente de movimientos pendiente de sincronización.
      sincronizarTodosLosMovimientosPendientes: null, // Cuando cambia de valor sincroniza todos los movimientos pendientes.
      resultadoUltimoCambioUbicacion: null, // Mantiene el resultado del ultimo cambio de ubicación.
      movimientosPendientesSincronizar: 0, // Mantiene el contador de los movimientos pendientes de sincronizar.
      temaBarraEstadoConexion: null, // Dependiendo de si es el frm trabaja en modo conectado o desconectado se personaliza el color de la barra.
      lecturaContinuaUbicacionesAPP: useParamRef('LecturaContinuaUbicacionesAPP'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'ubicacionesAlmacen',
    ]),

    CargarUbicacionesOfline() {
      const tempUbicaciones = this.ubicacionesAlmacen;
      if (tempUbicaciones == null) {
        HiNotification.Toast(this.$t('production.locations.changeConnectionMode.action.noLocationsAvailableOffline.text'));
        return [];
      }

      return tempUbicaciones;
    },

    statusText() {
      return this.modoConexionFrm === this.modosConexion.CONECTADO
        ? this.$t('production.locations.changeConnectionMode.modes.disconnected')
        : this.$t('production.locations.changeConnectionMode.modes.connected');
    },
  },
  watch: {
    modoConexionFrm(val) {
      this.CambioModoConexionRealizado(val);
    },
  },
  mounted() {
    this.InicializarFrm();
    this.ActivarListener();
  },
  beforeUnmount() {
    this.DesactivarListener();
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.modoConexionFrm = this.modosConexion.CONECTADO;

      if (this.lecturaContinuaUbicacionesAPP) {
        this.$refs.PCBuscadorPaleConfeccionado.modoLectura = this.$refs.PCBuscadorPaleConfeccionado.modosLectura.CODIGO;
      }
      this.ComprobarEstadoConexionActual();
      this.movimientosPendientesSincronizar = obtenerMovimientosDeAlmacenPendientes().length;
      // Si no tenemos las ubicaciones cargadas forzamos a cargarlas al entrar al formulario.
      if (this.ubicacionesAlmacen == null) {
        TraceabilityController.ObtenerTodasLasUbicacionesDisponibles();
      }
    },

    LimpiarValoresDelFrm() {
      Log(this, this.LimpiarValoresDelFrm.name);
      this.totalLecturasMultiples = 0;
      this.codigoDeBarrasParaBusqueda = null;
      this.elementosLeidosOnline = [];
      this.elementosLeidosOffline = [];
      this.elementoPaleSeleccionado = null;
      this.mostrarBtnConfirmarCambioDeUbicacion = false;
      this.$refs.UCUbicaciones.Clear();
    },

    ComprobarEstadoConexionActual() {
      Log(this, this.ComprobarEstadoConexionActual.name);
      if (navigator.onLine) {
        // el navegador está conectado a la red
        this.modoConexionFrm = this.modosConexion.CONECTADO;
      } else {
        // el navegador NO está conectado a la red
        this.modoConexionFrm = this.modosConexion.DESCONECTADO;
      }
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('PCBuscadorPaleConfeccionado_paleEstablecido', (elementoPale) => {
        this.ElementoPaleRecibido(elementoPale);
      });
      // Registramos eventos de conexion y desconexion
      document.addEventListener('offline', this.DetectadaPerdidaConexionDispositivo, false);
      document.addEventListener('online', this.DetectadaReconexionDispositivo, false);
    },

    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('PCBuscadorPaleConfeccionado_paleEstablecido');
      // Eliminamos los eventos de conexion y desconexion
      document.removeEventListener('offline', this.DetectadaPerdidaConexionDispositivo, false);
      document.removeEventListener('online', this.DetectadaReconexionDispositivo, false);
    },

    CambioModoConexionRealizado(modo) {
      Log(this, this.CambioModoConexionRealizado.name);
      this.temaBarraEstadoConexion = null;
      sleep(100).then(() => {
        if (modo === this.modosConexion.CONECTADO) {
          this.temaBarraEstadoConexion = {
            '--f7-navbar-bg-color': 'var(--f7-bars-bg-color)',
            '--f7-navbar-text-color': '#fff',
          };
        } else {
          this.temaBarraEstadoConexion = {
            '--f7-navbar-bg-color': 'var(--his-orange)',
            '--f7-navbar-text-color': '#fff',
          };
        }
      });
    },

    SolicitarCambioModoConexionFormulario() {
      Log(this, this.SolicitarCambioModoConexionFormulario.name);
      if ((this.elementosLeidosOnline != null && this.elementosLeidosOnline.length > 0)
        || (this.elementosLeidosOffline != null && this.elementosLeidosOffline.length > 0)
      ) {
        const alertTitle = this.$t('production.locations.changeConnectionMode.action.pendingReadingsConfirmation.title');
        const alertText = this.$t('production.locations.changeConnectionMode.action.pendingReadingsConfirmation.text');

        this.$refs.actionUbicaciones.create(
          alertTitle,
          alertText,
          () => {
            this.CambiarModoConexionFormulario();
          },
        );
        this.$refs.actionUbicaciones.show();
      } else {
        this.CambiarModoConexionFormulario();
      }
    },

    CambiarModoConexionFormulario() {
      Log(this, this.CambiarModoConexionFormulario.name);
      if (this.modoConexionFrm === this.modosConexion.CONECTADO) {
        // CAMBIAR MODO DESCONECTADO
        // Comprobamos que tengamos las ubicaciones cargadas, sino estan cargadas intentamos cargarlas
        // En caso de no ser posible cargar las ubicaciones informamos que no es posible utilizar el formulario en offline.
        const tempUbicaciones = this.ubicacionesAlmacen; // Obtenemos las ubicaciones almacenadas.
        if (tempUbicaciones == null) {
          const toastText = this.$t('production.locations.changeConnectionMode.action.noLocationsAvailableOffline.text');
          HiNotification.Toast(toastText);
          return;
        }
        this.modoConexionFrm = this.modosConexion.DESCONECTADO;
      } else {
        //  CAMBIAR MODO CONECTADO
        this.modoConexionFrm = this.modosConexion.CONECTADO;
      }
      // Restablecemos las variables.
      this.elementosLeidosOnline = [];
      this.elementosLeidosOffline = [];
      this.totalLecturasMultiples = 0;
      this.mostrarBtnConfirmarCambioDeUbicacion = false;

      const toastSuccessIcon = this.modoConexionFrm === this.modosConexion.CONECTADO
        ? '<i class="material-icons">signal_wifi_4_bar</i>'
        : '<i class="material-icons">signal_wifi_off</i>';

      const toastSuccessText = this.modoConexionFrm === this.modosConexion.CONECTADO
        ? this.$t('production.locations.changeConnectionMode.action.successToast.connected')
        : this.$t('production.locations.changeConnectionMode.action.successToast.disconnected');

      // Create toast with icon
      const toastIcon = f7.toast.create({
        icon: toastSuccessIcon,
        text: toastSuccessText,
        position: 'center',
        closeTimeout: 2000,
      });
      toastIcon.open();
    },

    OperacionesComunesLecturaCorrectaEfectuada() {
      Log(this, this.OperacionesComunesLecturaCorrectaEfectuada.name);
      this.totalLecturasMultiples += 1;
      this.mostrarBtnConfirmarCambioDeUbicacion = true;

      if (this.paramLecturaContinuaUbicacionesAPP) {
        nextTick(() => {
          this.$refs.PCBuscadorPaleConfeccionado.establecerEnfoqueCampoBusqueda();
        });
      }
    },

    // Elementos que se reciben desde el componente PCBuscarPaleConfeccionado
    ElementoPaleRecibido(elementoPale) {
      Log(this, this.ElementoPaleRecibido.name);
      if (this.modoConexionFrm === this.modosConexion.CONECTADO) {
        this.ProcesarElementoModoMultipleOnline(elementoPale);
      } else if (this.modoConexionFrm === this.modosConexion.DESCONECTADO) {
        this.ProcesarElementoModoMultipleOffline(elementoPale);
      }
    },

    ProcesarElementoModoMultipleOnline(elementoPale) {
      Log(this, this.ProcesarElementoModoMultipleOnline.name);
      if (this.elementosLeidosOnline.findIndex((e) => e.Id === elementoPale.Id) !== -1) {
        HiNotification.Toast(this.$t('production.locations.changeLocation.action.alreadyRead'));
        return;
      }
      this.elementosLeidosOnline.push(elementoPale);
      this.OperacionesComunesLecturaCorrectaEfectuada();
    },

    ProcesarElementoModoMultipleOffline(elementoPale) {
      Log(this, this.ProcesarElementoModoMultipleOffline.name);
      this.elementosLeidosOffline.push(elementoPale);
      this.OperacionesComunesLecturaCorrectaEfectuada();
    },

    FormatearFecha(fechaYHora) {
      Log(this, this.FormatearFecha.name);
      return SoporteFechaYHora.ObtenerDiaMesAno(fechaYHora);
    },

    ObtenerCantidadSumaEnvasesExistenciasDeUnPale(elementoPale) {
      Log(this, this.ObtenerCantidadSumaEnvasesExistenciasDeUnPale.name);
      let tempCantidadTotalEnvasesExistenciasDeUnPale = 0;
      elementoPale.Existencias.forEach((e) => {
        if (e.Articulo.TipoArticulo === 'Envase') {
          tempCantidadTotalEnvasesExistenciasDeUnPale += e.Cantidad;
        }
      });
      return tempCantidadTotalEnvasesExistenciasDeUnPale;
    },

    BorrarElementoOnline(elementoPale) {
      Log(this, this.BorrarElementoOnline.name);
      const tempPos = this.elementosLeidosOnline.indexOf(elementoPale);
      this.elementosLeidosOnline.splice(tempPos, 1);
      this.totalLecturasMultiples -= 1;
      if (this.totalLecturasMultiples === 0) {
        this.mostrarBtnConfirmarCambioDeUbicacion = false;
      }
    },

    BorrarElementoOffline(elementoPale) {
      Log(this, this.BorrarElementoOffline.name);
      const tempPos = this.elementosLeidosOffline.indexOf(elementoPale);
      this.elementosLeidosOffline.splice(tempPos, 1);
      this.totalLecturasMultiples -= 1;
      if (this.totalLecturasMultiples === 0) {
        this.mostrarBtnConfirmarCambioDeUbicacion = false;
      }
    },
    ConfirmarCambioDeUbicacion() {
      Log(this, this.ConfirmarCambioDeUbicacion.name);
      if (this.ubicacionDestino == null) {
        HiNotification.Toast(this.$t('common.needToSelectADestinationLocation'));
        return;
      }
      if (this.modoConexionFrm === this.modosConexion.CONECTADO) {
        this.ConfirmarCambioDeUbicacionOnline();
      }
      if (this.modoConexionFrm === this.modosConexion.DESCONECTADO) {
        this.ConfirmarCambioDeUbicacionOffline();
      }
    },

    ConfirmarCambioDeUbicacionOnline() {
      Log(this, this.ConfirmarCambioDeUbicacionOnline.name);
      const idsPales = SoporteGeneral.ObtenerCadenaIds(this.elementosLeidosOnline);
      const self = this;
      PreloaderGH(true, true);
      ConexionTA.callCambiarUbicacion(idsPales, this.ubicacionDestino.Id).then((result) => {
        if (result.Valor) {
          self.resultadoUltimoCambioUbicacion = JSON.parse(result.Mensaje);
          PreloaderGH(false);

          // comprobamos que haya alguna unidad logística con bloqueo lógico
          const res = self.resultadoUltimoCambioUbicacion.find((f) => !f.Resultado);
          if (res !== undefined) {
            HiNotification.Toast(this.$t('production.info.notAllLocationsChanged'));
          } else {
            HiNotification.Toast(this.$t('production.info.locationChanged'));
          }

          self.popupResumenMovimientoRealizado = true;
          self.LimpiarValoresDelFrm();
        } else {
          PreloaderGH(false);
          self.popupResumenMovimientoRealizado = true;
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
        // Restablecemos
        // self.elementosLeidosOnline = [];
        // self.totalLecturasMultiples = 0;
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('production.locations.changeLocation.action.toastErrorText'));
          LogError(error);
        });
    },

    ConfirmarCambioDeUbicacionOffline() {
      Log(this, this.ConfirmarCambioDeUbicacionOffline.name);
      const self = this;
      const auxMovimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los movimientos actuales.
      this.elementosLeidosOffline.forEach((element) => {
        const movimientoPendiente = {
          ElementoMover: element,
          UbicacionDestino: self.ubicacionDestino,
        };
        auxMovimientosPendientes.push(movimientoPendiente);
        self.mostrarBtnConfirmarCambioDeUbicacion = false;
      });
      guardarMovimientosDeAlmacenPendientes(auxMovimientosPendientes); // SoporteSincronizacion
      this.actualizarComponenteMovimientosPendientesSincronizacion = Date.now();
      this.movimientosPendientesSincronizar = auxMovimientosPendientes.length;
      this.elementosLeidosOffline = []; // Restablecemos
      this.totalLecturasMultiples = 0;
    },

    /** *** Método  UbicacionDestinoSeleccionada */
    UbicacionDestinoSeleccionada(ubicacion) {
      Log(this, this.UbicacionDestinoSeleccionada.name);
      this.ubicacionDestino = ubicacion;
      if (this.ubicacionDestino !== null) {
        if (this.ubicacionDestino !== null && this.paramLecturaContinuaUbicacionesAPP) {
          nextTick(() => {
            this.$refs.PCBuscadorPaleConfeccionado.establecerEnfoqueCampoBusqueda();
          });
        }
      }
    },

    //* * Método MostrarDetallePaleSeleccionado **
    MostrarDetallePaleSeleccionado(elementoPale) {
      Log(this, this.MostrarDetallePaleSeleccionado.name);
      this.elementoPaleSeleccionado = elementoPale;
      this.popupDetallePaleAbierto = true;
    },
    /** * Método CerrarDetallePaleSeleccionado */
    CerrarDetallePaleSeleccionado() {
      Log(this, this.CerrarDetallePaleSeleccionado.name);
      this.popupDetallePaleAbierto = false;
      this.elementoPaleSeleccionado = null;
    },
    /** * Método CerrarResumenDeMovimientosRealizados */
    CerrarResumenDeMovimientosRealizados() {
      Log(this, this.CerrarResumenDeMovimientosRealizados.name);

      if (this.paramLecturaContinuaUbicacionesAPP) {
        nextTick(() => {
          this.$refs.UCUbicaciones.$emit('establecerEnfoqueUbicacion');
        });
      }
    },
    /** * Método CerrarResumenDeMovimientosPendientes */
    CerrarResumenDeMovimientosPendientes() {
      Log(this, this.CerrarResumenDeMovimientosPendientes.name);
      this.movimientosPendientesSincronizar = obtenerMovimientosDeAlmacenPendientes().length;
    },
    /** * Método CerrarFrm */
    CerrarFrm(confirmacion) {
      Log(this, this.CerrarFrm.name);
      if (confirmacion || !navigator.onLine) {
        if (obtenerMovimientosDeAlmacenPendientes().length > 0) {
          HiNotification.Toast(this.$t('production.locations.closePage.willSyncWhenOnline'));
          ProgramarSincronizacionDeCambiosDeUbicacionPendientes();
        }
        f7.views.main.router.back();
        window.screen.orientation.unlock();
        return;
      }
      // Si tenemos movimientos pendientes de sincronizar y estamos online.
      if (obtenerMovimientosDeAlmacenPendientes().length > 0 && navigator.onLine) {
        const alertTitle = this.$t('production.locations.closePage.action.pendingReadingsConfirmation.title');
        const alertText = this.$t('production.locations.closePage.action.pendingReadingsConfirmation.text');

        this.$refs.actionConfirmarCambioDeModoConexionFrmAbierto.create(
          alertTitle,
          alertText,
          () => {
            this.SincronizarCambiosAntesDeSalirDelFrm();
          },
          () => {
            this.CerrarFrm(true);
          },

        );
        this.$refs.actionConfirmarCambioDeModoConexionFrmAbierto.show();
        return;
      }
      f7.views.main.router.back();
      window.screen.orientation.unlock();
    },

    /** * Método SincronizarCambiosAntesDeSalirDelFrm */
    SincronizarCambiosAntesDeSalirDelFrm() {
      Log(this, this.SincronizarCambiosAntesDeSalirDelFrm.name);
      this.popupResumenMovimientosPendientes = true;
      this.sincronizarTodosLosMovimientosPendientes = Date.now();
    },
    DetectadaPerdidaConexionDispositivo() {
      Log(this, this.DetectadaPerdidaConexionDispositivo.name);
      if (this.modoConexionFrm === this.modosConexion.CONECTADO && this.elementosLeidosOnline.length === 0) {
        this.CambiarModoConexionFormulario();
        HiNotification.Toast(this.$t('production.locations.connection.lost.toastText'));
      }
    },
    DetectadaReconexionDispositivo() {
      Log(this, this.DetectadaReconexionDispositivo.name);
      if (this.modoConexionFrm === this.modosConexion.DESCONECTADO && this.elementosLeidosOffline.length === 0) {
        this.CambiarModoConexionFormulario();
        HiNotification.Toast(this.$t('production.locations.connection.reconnected.toastText'));
      }
    },
    /** * Método EventoLecturaDeCodigoDeBarrasPale */
    EventoLecturaDeCodigoDeBarrasPale(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasPale.name);
      this.codigoDeBarrasParaBusqueda = codigoBarras;
    },
    EventUbicacionesSelected(obj) {
      Log(this, this.EventUbicacionesSelected.name);
      this.UbicacionDestinoSeleccionada(obj);
    },
    /* Ubicaciones */
    obtenerUbicacionPorCodigo(params) {
      Log(this, this.obtenerUbicacionPorCodigo.name);
      return ConexionTA.callObtenerUbicacionPorCodigo(params);
    },
    obtenerUbicaciones() {
      Log(this, this.obtenerUbicaciones.name);
      return ConexionTA.callObtenerUbicaciones();
    },
  },
});
</script>

<style lang="scss">
.main-location-control-home {
  // TODO: Remove when migrated to new styles
  --f7-tabbar-link-active-bg-color: transparent;
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-tabbar-link-font-weight: 300;

  .navbar-color {
    background-color: var(--his-darkgray) !important;
  }

  .div-componenteDeBusqueda {
    background: var(--his-tierra-white);
    min-height: 50px;
  }

  .div-contadorDeLecturasMultiples {
    width: 100%;
    background: #dcdcdc;
    padding-top: 5px;
    padding-bottom: 6px;

    span {
      padding-left: 15px;
    }
  }

  .componenteUCEscanearCodigoPosicionarIzquierda {
    left: 35%;
  }

  .btn-navBar-Movimientos {
    width: 65px;
  }

  .col-mensajeDeError {
    padding-top: 10px;
  }

  .col-resultadoMovimiento {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .div-contenedorLecturasMultiples {
    margin-bottom: 80px;
  }

  .badge-indicadorMovimientos {
    margin-bottom: 25px;
    background: var(--his-tomate-dark);
  }

  .fab-btnConfirmarCambioDeUbicacion {
    padding-right: 5%;
  }

  .div-compontePCExistenciasDeUnPalePrecalibradoConInformacionDeUbicaciones {
    margin-top: -20px;
  }

  .div-campoDeBusquedaUbicacion {
    background: var(--his-tierra-white);
    padding: var(--f7-typography-margin);
  }

  .div-qr-search {
    padding-right: 6vw;
    padding-left: 6vw;
  }

  .block-title {
    margin-top: 0;
  }

  .span-cantidadEnvases {
    color: var(--his-darkgray);
    font-size: 18px;
    font-weight: 500;
    font-weight: bold;
    margin-left: 10px;
  }

  .div-registroElementoLeido {
    margin-left: 28px;
    padding-right: 28px;
    padding-bottom: 15px;
    margin-top: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid var(--his-disabled);
    display: flex;
    align-items: center;
  }
}
</style>
